import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, Platform } from 'ionic-angular';
import { Fiesta } from '../../models/fiesta.model';
import { BuscadorPage } from '../buscador/buscador';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the FiestaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-fiesta',
  templateUrl: 'fiesta.html',
})
export class FiestaPage {
  public fiesta:Fiesta;
  public lat_empresa: number;
  public long_empresa: number;
  public latitude:number;
  public longitude:number;


  constructor(public navCtrl: NavController,
     public platform: Platform,
     public navParams: NavParams,
     public menuCtrl:MenuController,
     public global: VariablesGlobales) {
    this.fiesta = this.navParams.get("fiesta");
    this.convertUrlToCoordenates(this.fiesta.mapa);
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  compartir(){

  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad FiestaPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
  convertUrlToCoordenates(mapa){
    if(mapa) {
          if (mapa.includes("@")) {
              let aux = mapa.split("@");
              let aux2 = aux[1].split(",");
              this.lat_empresa = parseFloat(aux2[0]);
              this.long_empresa = parseFloat(aux2[1]);
          }
    }
  }
  goToNavigation(){

    let destination = this.lat_empresa + ',' + this.long_empresa;
    let origin = this.latitude+","+this.longitude;
      if(this.platform.is('ios')){
        window.open('maps://?q=' + destination, '_system');
      } else {
        window.open("https://www.google.es/maps/dir/"+origin+"/"+destination+"/")
      }
  }

  goToFile(file){
    window.open(VariablesGlobales.urlServidor + VariablesGlobales.fiestasPdfs + file);
  }
}



// WEBPACK FOOTER //
// ./src/pages/fiesta/fiesta.ts